module.exports = __webpack_public_path__ + "img/hyh_logo.1bc09559.png";